import React from 'react';
import { PageContainerWithLogo } from './PageContainerWithLogo.tsx';
import { ErrorCard } from 'design-system/src/components/ErrorCard/ErrorCard';
import { Typography } from 'design-system/src/components/Typography/Typography';
import { useNavigate } from 'react-router-dom';
import Button from 'design-system/src/components/Button/Button';
import { PROVIDER_SUPPORT_CONTACT_INFO } from '../../constants';

interface SignupErrorProps {
  errorTitle?: string;
  errorMessage?: string;
  children?: React.ReactNode;
}

const defaultErrorMessage = (
  <Typography styledAs="bodyDMSans">
    Please retry signing up or contact our team at{' '}
    <Button href={`mailto:${PROVIDER_SUPPORT_CONTACT_INFO.email}`} variant="link">
      {PROVIDER_SUPPORT_CONTACT_INFO.email}
    </Button>
    .
  </Typography>
);

export const SignupError: React.FC<SignupErrorProps> = ({
  errorTitle = 'Something went wrong',
  errorMessage = defaultErrorMessage,
}) => {
  const navigate = useNavigate();
  return (
    <PageContainerWithLogo>
      <ErrorCard>
        <Typography styledAs="h6">{errorTitle}</Typography>
        <Typography styledAs="bodyDMSans">{errorMessage}</Typography>
        <Button width="full" variant="secondary" onClick={() => navigate('/signup', { replace: true })}>
          Go back to signup
        </Button>
      </ErrorCard>
    </PageContainerWithLogo>
  );
};
